import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { makeApiCall } from "src/api/apiRequests";
import { LanguageDate } from "src/helpers/CheckLanguageDate";
import EvaluationStars from "src/components/panel/performance/EvaluationStars";
import API_HEADERS from "src/api/apiConfig";
import API_PATHS from "src/api/apiPaths";
import FLASH_MESSAGES from "src/helpers/FlashMessages";
import moment from "moment";
interface ShowEvaluationTeacherProps {
  onShowModal: boolean;
  setShowModal: (visible: boolean) => void;
  evaluationId: number;
}

const ShowEvaluationTeacher: React.FC<ShowEvaluationTeacherProps> = ({
  onShowModal,
  setShowModal,
  evaluationId,
}) => {
  const { t } = useTranslation("");

  const [teacherEvaluationDate, setTeacherEvaluationDate] =
    useState<Date | null>(null);
  const [teacherEvaluationComment, setTeacherEvaluationComment] =
    useState<string>("");
  const [teacherEvaluationScore, setTeacherEvaluationScore] =
    useState<string>("");
  const [loading, setLoading] = useState(true);

  const getShowTeacherEvaluationData = async (): Promise<void> => {
    try {
      const response: any = await makeApiCall<ResponseType>(
        API_PATHS.teacherEvaluationDetails(evaluationId),
        "GET",
        API_HEADERS.authenticated
      );
      setTeacherEvaluationDate(response.teacher_evaluation.evaluation_date);
      setTeacherEvaluationComment(
        response.teacher_evaluation.evaluation_comment
      );
      setTeacherEvaluationScore(response.teacher_evaluation.evaluation_score);
      setLoading(false);
    } catch (error: any) {
      FLASH_MESSAGES.errorMsg(error.response.data.error);
      onClose();
    }
  };

  useEffect(() => {
    getShowTeacherEvaluationData();
  }, []);

  const onClose = () => {
    setShowModal(false);
  };

  return (
    <Modal
      isOpen={onShowModal && !loading}
      toggle={() => onClose()}
      size="md"
      centered
    >
      <ModalHeader
        className="text-dark font-size-15"
        toggle={() => onClose()}
        tag="span"
      >
        {t("show_teacher_evaluation_title")}
      </ModalHeader>
      <ModalBody>
        <div className="modal-note">{t("show_teacher_evaluation_details")}</div>
        <div className="d-flex border-bottom modal-requests">
          <div className="modal-sections mb-4">
            <span className="header-text">
              {t("show_teacher_evaluation_date")}
            </span>
            <span className="bold-text">
              {teacherEvaluationDate
                ? moment(teacherEvaluationDate)
                    .locale(LanguageDate.moment)
                    .format("DD, MMMM yyyy")
                : "-"}
            </span>
          </div>
          <div className="modal-sections">
            <span className="header-text">{t("show_teacher_evaluation")}</span>
            <span className="bold-text">
              {teacherEvaluationScore ? (
                <EvaluationStars
                  evaluationNr={Number(teacherEvaluationScore)}
                />
              ) : (
                "-"
              )}
            </span>
          </div>
        </div>

        <div className="d-flex mt-3 mb-4 modal-requests">
          <div className="modal-sections">
            <span className="modal-note">
              {t("show_teacher_evaluation_comments")}
            </span>
            <span className="bold-text">
              {teacherEvaluationComment ? teacherEvaluationComment : "-"}
            </span>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          className="button-white"
          type="button"
          onClick={() => onClose()}
        >
          {t("show_teacher_evaluation_close")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ShowEvaluationTeacher;
